import { StyledRootBox } from '../styled'

export const RootBox: React.FC = ({ children }) => {
  return <StyledRootBox className="root-box">{children}</StyledRootBox>
}
